class StrongholdSeries extends HTMLElement {
  connectedCallback() {
    this.initAttempts = 0;
    this.tryInit();
  }

  tryInit() {
    if (this._swiper) return;

    const container = this.querySelector('[data-stronghold-swiper]');
    if (!container) return;

    if (typeof Swiper === 'undefined') {
      this.initAttempts += 1;
      if (this.initAttempts < 80) {
        requestAnimationFrame(() => this.tryInit());
      }
      return;
    }

    const slides = container.querySelectorAll('.swiper-slide');
    const paginationEl = this.querySelector('[data-stronghold-pagination]');

    if (slides.length === 0) {
      return;
    }

    if (slides.length < 2 && paginationEl) {
      paginationEl.style.display = 'none';
    }

    this._swiper = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      pagination:
        slides.length > 1 && paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : undefined,
    });
  }

  disconnectedCallback() {
    if (this._swiper) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }
}

if (!customElements.get('stronghold-series')) {
  customElements.define('stronghold-series', StrongholdSeries);
}
